import * as React from 'react';
import {
    Edit,
    TextInput,
    FileInput,
    FileField,
    TabbedForm,
    useTranslate,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import SegmentsFormToolbar from './SegmentsFormToolbar';
import { RichTextInput } from '../components/RichTextInput';

const EmailsForm = () => {
    const translate = useTranslate();
    const formDefaults = {
        multiple: true,
        method: 'post',
    };
    return (
        <Edit resource="settings" redirect={false} mutationMode="pessimistic">
            <Box>
                <Typography variant="h4" padding={2}>
                    {translate('resources.settings.fieldGroups.emails')}
                </Typography>
                <TabbedForm
                    defaultValues={formDefaults}
                    toolbar={<SegmentsFormToolbar />}
                    syncWithLocation={false}
                >
                    <TabbedForm.Tab label="resources.settings.fieldGroups.emails_registration">
                        <TextInput
                            source="Emails__registrationValidationSubject"
                            label="resources.settings.values.emails__registrantion_validation_subject"
                            fullWidth
                        />
                        <RichTextInput
                            source="Emails__registrationValidationText"
                            label="resources.settings.values.emails__registrantion_validation_text"
                            fullWidth
                        />
                        <FileInput
                            source="Emails__registrationValidationFile0"
                            label="resources.settings.values.emails__registrantion_validation_file_0"
                            fullWidth
                        >
                            <FileField source="src" title="title" />
                        </FileInput>
                        <FileInput
                            source="Emails__registrationValidationFile1"
                            label="resources.settings.values.emails__registrantion_validation_file_1"
                            fullWidth
                        >
                            <FileField source="src" title="title" />
                        </FileInput>
                        <FileInput
                            source="Emails__registrationValidationFile2"
                            label="resources.settings.values.emails__registrantion_validation_file_2"
                            fullWidth
                        >
                            <FileField source="src" title="title" />
                        </FileInput>
                        <FileInput
                            source="Emails__registrationValidationFile3"
                            label="resources.settings.values.emails__registrantion_validation_file_3"
                            fullWidth
                        >
                            <FileField source="src" title="title" />
                        </FileInput>
                        <FileInput
                            source="Emails__registrationValidationFile4"
                            label="resources.settings.values.emails__registrantion_validation_file_4"
                            fullWidth
                        >
                            <FileField source="src" title="title" />
                        </FileInput>
                    </TabbedForm.Tab>
                </TabbedForm>
            </Box>
        </Edit>
    );
};

export default EmailsForm;
